import React from 'react';
import { RouteComponentProps } from '@reach/router';

// JME
// import { useAuthHook } from '#utils/useAuthHook';
// JME1
import { useAuth } from '#core/Auth';
import PrivateRoute from '../PrivateRoute';
import PublicRoute from '../PublicRoute';
import { PageConfig } from '../../config/products';

interface PublicAndPrivateRouteProps extends RouteComponentProps {
  privateLayout?: React.FC<{}>;
  publicLayout?: React.FC<{}>;
  layoutConfig?: DeepPartial<PageConfig>;
  publicComponent: React.ComponentType<RouteComponentProps>;
  privateComponent: React.FC<{ pageConfig: PageConfig } & RouteComponentProps>;
  path?: string;
  default?: boolean;
  auth?: {
    resource: string;
    action: string;
  };
  errorBoundaryId: string;
  productName?: string;
  pageName?: string;
  trackingPageGroup: string;
  privateTrackingPageName: string;
  publicTrackingPageName: string;
  privatePageTitle: string;
  publicPageTitle: string;
}

const PublicAndPrivateRoute: React.FC<PublicAndPrivateRouteProps> = ({
  privateComponent,
  privateLayout,
  publicComponent,
  publicLayout,
  privateTrackingPageName,
  publicTrackingPageName,
  privatePageTitle,
  publicPageTitle,
  ...props
}) => {
  const { isAuthenticated } = useAuth(); // JME2

  if (isAuthenticated) {
    return (
      <PrivateRoute
        {...props}
        trackingPageName={privateTrackingPageName}
        component={privateComponent}
        layout={privateLayout}
        pageTitle={privatePageTitle}
      />
    );
  }

  return (
    <PublicRoute
      {...props}
      trackingPageName={publicTrackingPageName}
      component={publicComponent}
      layout={publicLayout}
      pageTitle={publicPageTitle}
    />
  );
};

export default PublicAndPrivateRoute;
